import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "flex max-h-[92vh] flex-col overflow-hidden rounded-2xl bg-slate-100 shadow-2xl"
};
const _hoisted_2 = {
  class: "flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3"
};
const _hoisted_3 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_4 = {
  class: "flex items-start justify-center gap-6 overflow-auto p-6"
};
const _hoisted_5 = {
  class: "mp-title-section"
};
const _hoisted_6 = {
  class: "mp-title-row"
};
const _hoisted_7 = {
  class: "mp-service-title"
};
const _hoisted_8 = {
  class: "mp-service-desc"
};
const _hoisted_9 = {
  key: 0,
  class: "mp-price-section"
};
const _hoisted_10 = {
  class: "mp-price-value"
};
const _hoisted_11 = {
  key: 0,
  class: "mp-price-suffix"
};
const _hoisted_12 = {
  key: 1,
  class: "mp-price-section"
};
const _hoisted_13 = {
  key: 2,
  class: "mp-info-cards"
};
const _hoisted_14 = {
  key: 0,
  class: "mp-info-card"
};
const _hoisted_15 = {
  class: "mp-card-value"
};
const _hoisted_16 = {
  key: 1,
  class: "mp-info-card"
};
const _hoisted_17 = {
  class: "mp-card-value"
};
const _hoisted_18 = {
  key: 3,
  class: "mp-section"
};
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  key: 4,
  class: "mp-section"
};
const _hoisted_21 = {
  class: "mp-materials-card"
};
const _hoisted_22 = {
  class: "mp-material-name"
};
const _hoisted_23 = {
  key: 0,
  class: "mp-material-tag required"
};
const _hoisted_24 = {
  key: 1,
  class: "mp-material-tag optional"
};
const _hoisted_25 = {
  key: 5,
  class: "mp-section"
};
const _hoisted_26 = {
  class: "mp-timeline"
};
const _hoisted_27 = {
  class: "mp-timeline-dot-wrapper"
};
const _hoisted_28 = {
  class: "mp-timeline-dot"
};
const _hoisted_29 = {
  class: "mp-timeline-step-num"
};
const _hoisted_30 = {
  key: 0,
  class: "mp-timeline-line"
};
const _hoisted_31 = {
  class: "mp-timeline-title"
};
const _hoisted_32 = {
  key: 0,
  class: "mp-timeline-desc"
};
const _hoisted_33 = {
  key: 6,
  class: "mp-section"
};
const _hoisted_34 = {
  class: "mp-warning-card"
};
const _hoisted_35 = {
  class: "mp-warning-text"
};
const _hoisted_36 = {
  key: 7,
  class: "mp-section mp-deliverables-section"
};
const _hoisted_37 = {
  class: "mp-deliverables-grid"
};
const _hoisted_38 = {
  class: "mp-deliverable-name"
};
const _hoisted_39 = {
  class: "w-64 shrink-0"
};
const _hoisted_40 = {
  class: "rounded-xl border border-slate-200 bg-white p-4"
};
const _hoisted_41 = {
  class: "grid grid-cols-3 gap-y-4"
};
const _hoisted_42 = {
  class: "flex flex-col items-center",
  style: {
    "gap": "10px"
  }
};
const _hoisted_43 = {
  class: "mp-grid-icon"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  key: 1,
  class: "mp-icon mp-icon-description",
  style: {
    "color": "#2BA6E0"
  }
};
const _hoisted_46 = {
  class: "mp-grid-name"
};
const _hoisted_47 = {
  class: "rounded-xl border border-slate-200 bg-white p-3"
};
const _hoisted_48 = {
  class: "mp-hot-card"
};
const _hoisted_49 = {
  class: "mp-grid-icon mp-hot-icon"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  key: 1,
  class: "mp-icon mp-icon-description",
  style: {
    "color": "#2BA6E0"
  }
};
const _hoisted_52 = {
  class: "mp-hot-info"
};
const _hoisted_53 = {
  class: "mp-hot-name"
};
const _hoisted_54 = {
  class: "mp-hot-desc"
};
const _hoisted_55 = {
  class: "mp-hot-right"
};
const _hoisted_56 = {
  class: "mp-hot-price"
};
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getProductDetail } from '@/api/product';
import MpPhoneFrame from '@/components/MpPhoneFrame.vue';
export default {
  __name: 'ProductPreviewModal',
  props: {
    // 控制显示
    modelValue: {
      type: Boolean,
      default: false
    },
    // 已保存产品：传产品ID，组件自动加载详情（管理端接口草稿优先，含待审修改）
    productId: {
      type: [String, Number],
      default: null
    },
    // 编辑中未保存内容：直接传入表单快照，无需请求接口
    // 形状：{ name, shortName, iconUrl, summary, detailContent, serviceScope, processSteps,
    //        durationDays, deliverables, notices, materials: [{name, isRequired}], priceModels: [{priceDisplay, unit}] }
    previewData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const hasDraftVersion = ref(false);
    const info = reactive({
      name: '',
      listName: '',
      iconUrl: '',
      description: '',
      priceDisplay: '',
      priceSuffix: '',
      duration: '',
      target: '',
      detailContent: '',
      materials: [],
      steps: [],
      notice: '',
      deliverables: []
    });
    const hintText = computed(() => {
      if (props.previewData) {
        return '预览当前编辑内容（包含未保存的修改）';
      }
      return hasDraftVersion.value ? '当前展示为待审草稿内容，发布新版/上架审批通过后对外生效' : '当前展示为线上生效内容';
    });
    const close = () => emit('update:modelValue', false);

    /** 与小程序 extractPrice 保持一致：取第一个价格模型的展示价与单位 */
    const extractPrice = priceModels => {
      if (!priceModels || !priceModels.length) return {
        display: '',
        suffix: ''
      };
      const model = priceModels[0];
      return {
        display: model.priceDisplay || '',
        suffix: model.unit ? `/${model.unit}` : ''
      };
    };

    /** 与小程序 parseSteps 保持一致：支持 JSON 字符串、数组或换行文本 */
    const parseSteps = processSteps => {
      if (!processSteps) return [];
      if (Array.isArray(processSteps)) {
        return processSteps.map((s, i) => ({
          title: s.title || s.name || `步骤${i + 1}`,
          desc: s.desc || s.description || ''
        }));
      }
      try {
        const parsed = JSON.parse(processSteps);
        if (Array.isArray(parsed)) {
          return parsed.map((s, i) => ({
            title: s.title || s.name || `步骤${i + 1}`,
            desc: s.desc || s.description || ''
          }));
        }
      } catch (e) {/* 非 JSON，按纯文本处理 */}
      return String(processSteps).split(/\n|；|;/).filter(s => s.trim()).map((s, i) => ({
        title: `步骤${i + 1}`,
        desc: s.trim()
      }));
    };

    /** 与小程序 parseList 保持一致：支持 JSON 数组或分隔符文本 */
    const parseList = str => {
      if (!str) return [];
      if (Array.isArray(str)) {
        return str.map(d => ({
          name: typeof d === 'string' ? d : d.name || d
        }));
      }
      try {
        const parsed = JSON.parse(str);
        if (Array.isArray(parsed)) {
          return parsed.map(d => ({
            name: typeof d === 'string' ? d : d.name || d
          }));
        }
      } catch (e) {/* 非 JSON，按纯文本处理 */}
      return String(str).split(/\n|，|,|、|；|;/).filter(s => s.trim()).map(s => ({
        name: s.trim()
      }));
    };

    /** 统一映射为小程序 serviceInfo 结构 */
    const fillInfo = raw => {
      const priceInfo = extractPrice(raw.priceModels);
      info.name = raw.name || '';
      info.listName = raw.shortName || raw.name || '';
      info.iconUrl = raw.iconUrl || raw.icon || '';
      info.description = raw.summary || '';
      info.priceDisplay = priceInfo.display;
      info.priceSuffix = priceInfo.suffix;
      info.duration = raw.durationDays ? `${raw.durationDays}个工作日` : '';
      info.target = raw.serviceScope || '';
      info.detailContent = raw.detailContent || '';
      info.materials = (raw.materials || []).map(m => ({
        name: m.name,
        isRequired: m.isRequired === 1 || m.isRequired === true
      }));
      info.steps = parseSteps(raw.processSteps);
      info.notice = raw.notices || '';
      info.deliverables = parseList(raw.deliverables);
    };
    const loadDetail = async () => {
      loading.value = true;
      try {
        const data = await getProductDetail(props.productId);
        hasDraftVersion.value = !!data?.hasDraftVersion;
        fillInfo(data || {});
      } catch (error) {
        console.error('loadProductPreview failed:', error);
        ElMessage.error(error.message || '加载产品详情失败');
      } finally {
        loading.value = false;
      }
    };
    watch(() => props.modelValue, visible => {
      if (!visible) return;
      hasDraftVersion.value = false;
      if (props.previewData) {
        fillInfo(props.previewData);
      } else if (props.productId) {
        loadDetail();
      }
    });
    return (_ctx, _cache) => {
      return __props.modelValue ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4",
        onClick: _withModifiers(close, ["self"])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "小程序预览", -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(hintText.value), 1)]), _createElementVNode("button", {
        onClick: close,
        class: "rounded-full p-1 text-slate-400 hover:text-slate-600",
        "aria-label": "关闭预览"
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("div", _hoisted_4, [_createVNode(MpPhoneFrame, {
        title: "服务详情",
        loading: loading.value
      }, {
        cta: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("div", {
          class: "mp-cta"
        }, [_createElementVNode("div", {
          class: "mp-cta-button"
        }, [_createElementVNode("span", {
          class: "mp-icon mp-icon-support"
        }), _createElementVNode("span", {
          class: "mp-cta-text"
        }, "立即咨询")])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(info.name), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "mp-fav-btn"
        }, [_createElementVNode("svg", {
          class: "mp-fav-icon",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        })])], -1))]), _createElementVNode("span", _hoisted_8, _toDisplayString(info.description), 1)]), info.priceDisplay ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "mp-price-symbol"
        }, "¥", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(info.priceDisplay), 1), info.priceSuffix ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(info.priceSuffix), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
          class: "mp-price-value mp-price-negotiable"
        }, "面议", -1)]))])), info.duration || info.target ? (_openBlock(), _createElementBlock("div", _hoisted_13, [info.duration ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "mp-card-header"
        }, [_createElementVNode("span", {
          class: "mp-icon mp-icon-schedule"
        }), _createElementVNode("span", {
          class: "mp-card-label"
        }, "预计周期")], -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(info.duration), 1)])) : _createCommentVNode("", true), info.target ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "mp-card-header"
        }, [_createElementVNode("span", {
          class: "mp-icon mp-icon-groups"
        }), _createElementVNode("span", {
          class: "mp-card-label"
        }, "适用对象")], -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(info.target), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), info.detailContent ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[7] || (_cache[7] = _createElementVNode("span", {
          class: "mp-section-title"
        }, "服务内容", -1)), _createElementVNode("div", {
          class: "mp-detail-content",
          innerHTML: info.detailContent
        }, null, 8, _hoisted_19)])) : _createCommentVNode("", true), info.materials.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "mp-section-title"
        }, "准备材料", -1)), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.materials, (material, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mp-material-item",
            key: index
          }, [_cache[8] || (_cache[8] = _createElementVNode("div", {
            class: "mp-material-icon"
          }, [_createElementVNode("span", {
            class: "mp-icon mp-icon-description"
          })], -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(material.name), 1), material.isRequired ? (_openBlock(), _createElementBlock("span", _hoisted_23, "必需")) : (_openBlock(), _createElementBlock("span", _hoisted_24, "选填"))]);
        }), 128))])])) : _createCommentVNode("", true), info.steps.length ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "mp-section-title"
        }, "服务流程", -1)), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.steps, (step, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mp-timeline-item",
            key: index
          }, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(index + 1), 1)]), index < info.steps.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_30)) : _createCommentVNode("", true)]), _createElementVNode("div", {
            class: _normalizeClass(["mp-timeline-content", {
              'last': index === info.steps.length - 1
            }])
          }, [_createElementVNode("span", _hoisted_31, _toDisplayString(step.title), 1), step.desc ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(step.desc), 1)) : _createCommentVNode("", true)], 2)]);
        }), 128))])])) : _createCommentVNode("", true), info.notice ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "mp-warning-header"
        }, [_createElementVNode("span", {
          class: "mp-icon mp-icon-warning"
        }), _createElementVNode("span", {
          class: "mp-warning-title"
        }, "注意事项")], -1)), _createElementVNode("span", _hoisted_35, _toDisplayString(info.notice), 1)])])) : _createCommentVNode("", true), info.deliverables.length ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "mp-section-title"
        }, "交付物", -1)), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.deliverables, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mp-deliverable-item",
            key: index
          }, [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "mp-deliverable-icon"
          }, [_createElementVNode("span", {
            class: "mp-icon mp-icon-verified"
          })], -1)), _createElementVNode("span", _hoisted_38, _toDisplayString(item.name), 1)]);
        }), 128))])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading"]), _createElementVNode("div", _hoisted_39, [_cache[17] || (_cache[17] = _createElementVNode("p", {
        class: "mb-2 text-xs font-medium text-slate-500"
      }, "服务列表 / 热门专题入口", -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [info.iconUrl ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: info.iconUrl,
        class: "h-6 w-6 object-contain",
        alt: ""
      }, null, 8, _hoisted_44)) : (_openBlock(), _createElementBlock("span", _hoisted_45))]), _createElementVNode("span", _hoisted_46, _toDisplayString(info.listName || '-'), 1)]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
        return _createElementVNode("div", {
          key: i,
          class: "flex flex-col items-center opacity-40",
          style: {
            "gap": "10px"
          }
        }, [...(_cache[15] || (_cache[15] = [_createElementVNode("div", {
          class: "mp-grid-icon mp-grid-icon-placeholder"
        }, null, -1), _createElementVNode("span", {
          class: "mp-grid-name text-slate-300"
        }, "其他服务", -1)]))]);
      }), 64))])]), _cache[18] || (_cache[18] = _createElementVNode("p", {
        class: "mb-2 mt-4 text-xs font-medium text-slate-500"
      }, "首页\"热门服务推荐\"卡片（仅设为热门时展示）", -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [info.iconUrl ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: info.iconUrl,
        class: "h-6 w-6 object-contain",
        alt: ""
      }, null, 8, _hoisted_50)) : (_openBlock(), _createElementBlock("span", _hoisted_51))]), _createElementVNode("div", _hoisted_52, [_createElementVNode("span", _hoisted_53, _toDisplayString(info.name || '-'), 1), _createElementVNode("span", _hoisted_54, _toDisplayString(info.description || ''), 1)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(info.priceDisplay || '面议'), 1), _cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "mp-hot-btn"
      }, "咨询", -1))])])]), _cache[19] || (_cache[19] = _createElementVNode("p", {
        class: "mt-2 text-xs leading-5 text-slate-400"
      }, "列表与热门专题展示图标与短名（短名为空时显示产品名称）；首页热门卡片展示产品名称、摘要与展示价。", -1))])])])])) : _createCommentVNode("", true);
    };
  }
};